<template>
  <div class="mt-4">
    <ToogleFilterBox classString="mx-4 px-0" title="Filtrar" :isFilter="true" @filter="filter" @resetFilter="resetFilter">
        <div class="row m-0 w-100 mb-2">
          <b-form-group label="Empresa:" label-for="empresa" class= "col-lg-3 col-12 px-1 mb-2">
              <InputAutocomplete :loader="empresaAutocompleteLoader" v-model="form.empresa" />
          </b-form-group>
          <b-form-group id="input-group-2" label="Nome:" label-for="v" class="col-lg-3 col-12 px-1">
              <b-form-input 
                id="name"
                v-model="form.name"
              ></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="Tipo:" label-for="tipo" class="col-lg-3 col-12 px-1">
            <b-form-select id="tipo" v-model="form.tipo" :options="statusOptions"></b-form-select>
          </b-form-group>
          <b-form-group id="input-group-2" label="Ano:" label-for="ano" class="col-lg-3 col-12 px-1">
            <InputDate2 label="" v-model="form.ano"/>
          </b-form-group>          
        </div>        
      </ToogleFilterBox>
  </div>
</template>

<script>
import Validations from '@/util/Validations'
import InputDate2 from "@/components/commons/Inputs/InputDate2"
import EmpresaResource from "@/resources/EmpresaResource"
import InputAutocomplete from "@/components/commons/Inputs/InputAutocomplete"
import ToogleFilterBox from "@/components/commons/ToogleFilterBox.vue";

export default {
    name: "HistoricoInativacaoFilter",
    components: {
        InputDate2,
        InputAutocomplete,
        ToogleFilterBox
    },
    data() {
      return {
        form : {
            tipo: null,
            name: null,
            ano: null,
            empresa: null,
            showWeekNumber: false,
            locale: 'pt-BR'
        },
        statusOptions : [
            { value: null, text: '(Selecione)'},
            { value: 1,  text:'Funcionário'},
            { value: 2 , text: 'Dependente'},
        ]
      }
	},
   methods: {
      empresaAutocompleteLoader: EmpresaResource.autocomplete,
      clearDate () {
            this.form.ano = null
      },
      filter() {
        if( Validations.isEmpty(this.form) ) {
          this.$emit("filter-historico-inativacao", {} )    
        }
        else {
            let form = {
                ...this.form,
                tipo: this.form.tipo,
                name: this.form.name != null ? this.form.name.toUpperCase() : null,
                ano: this.form.ano,
                empresa : this.form.empresa != null ? this.form.empresa.id : null
            }

          this.$emit("filter-historico-inativacao", form)
        }        
      },
      resetFilter() {
          for (let key in this.form)
          {
              this.form[key] = null
          }  
      },
    }
}
</script>
<style scoped>
.consultar-empresa-filtro {
	justify-content: space-between;
  color: #707070;
	font-size: 18px;
	text-align: left;
}

.label-filter-cases {
    width: 100%;
    height: 45px;
    color: #EFEFEE !important;    
    background-color: #bbbec0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    letter-spacing: 2px !important;
    border-radius: 10px 10px 0px 0px;
    transition: 0.2s;
}

.label-filter-cases:hover{
    cursor: pointer;
    background-color: #9d9fa0;
}

input, select {
    font-size: 14px !important;
    border: 1px solid #bbbec0 !important;  
}

.form-filter-cases, .form-filter-cases-end  {
    width: 100%;
    display: flex;
    padding: 15px 0px;
    flex-wrap: wrap;
    justify-content: flex-start;
    transition: 0.2s;
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
}

.form-filter-cases-end { 
  justify-content: flex-end;
}

.input-100-filter-cases{
    width: calc(100% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-20-filter-cases {
    width: calc(20% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-50-filter-cases {
    width: calc(50% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-40-filter-cases {
    width: calc(50% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-25-filter-cases {
    width: calc(25% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-35-filter-cases {
    width: calc(35% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-15-filter-cases {
    width: calc(15% - 20px);
    margin: 0px 10px 10px 10px;
}

</style>